import { useState, useCallback, useEffect } from 'react';
import { GoogleMap, Marker } from '@react-google-maps/api';
import { jsx } from '@emotion/react/jsx-runtime';

const DEFAULT_MAP_CENTER = {
  lat: 40.4233,
  lng: -3.7058048
};
const STYLES = [{
  stylers: [{
    lightness: 40
  }]
}, {
  elementType: 'geometry',
  featureType: 'administrative',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'poi',
  stylers: [{
    visibility: 'off'
  }]
}, {
  elementType: 'labels.icon',
  featureType: 'road',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'transit',
  stylers: [{
    visibility: 'off'
  }]
}, {
  featureType: 'transit.line',
  stylers: [{
    visibility: 'on'
  }]
}, {
  featureType: 'transit.station',
  stylers: [{
    visibility: 'on'
  }]
}];
function useMap(markers, mapCenterPos) {
  const [map, setMap] = useState(null);
  const onUnmount = useCallback(() => setMap(null), []);
  const onLoad = useCallback(map => setMap(map), []);
  useEffect(() => {
    if (!map) return;
    const bounds = new google.maps.LatLngBounds();
    markers.forEach(_ref => {
      let {
        position
      } = _ref;
      bounds.extend(position);
    });
    map.fitBounds(bounds);
  }, [markers, map]);
  useEffect(() => {
    if (map && mapCenterPos) {
      map.panTo(mapCenterPos);
    }
  }, [map, mapCenterPos]);
  return {
    onLoad,
    onUnmount
  };
}
const Map = _ref2 => {
  let {
    markers,
    mapCenterPos,
    zoom = 11,
    zoomControl = false,
    mapTypeControl = false,
    scaleControl = false,
    streetViewControl = false,
    rotateControl = false,
    fullscreenControl = false,
    markerIcon,
    onMarkerClick,
    onIdle
  } = _ref2;
  const mapControls = {
    fullscreenControl,
    mapTypeControl,
    rotateControl,
    scaleControl,
    streetViewControl,
    zoomControl
  };
  const loadAndUmount = useMap(markers, mapCenterPos);
  const center = mapCenterPos || (markers.length ? markers[0].position : DEFAULT_MAP_CENTER);
  return jsx(GoogleMap, {
    ...loadAndUmount,
    zoom: zoom,
    center: center,
    onIdle: () => onIdle === null || onIdle === void 0 ? void 0 : onIdle(),
    options: {
      ...mapControls,
      styles: STYLES
    },
    mapContainerStyle: {
      height: '100%',
      width: '100%'
    },
    children: markers.map((_ref3, key) => {
      let {
        id,
        icon = markerIcon,
        ...rest
      } = _ref3;
      return jsx(Marker, {
        icon: icon,
        onClick: () => onMarkerClick === null || onMarkerClick === void 0 ? void 0 : onMarkerClick(id),
        ...rest
      }, key);
    })
  });
};

export { Map, useMap };
//# sourceMappingURL=Map.js.map
